export * from './AccommodationFloatingHeader'
